"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchCampusGroups = exports.searchCampusDevices = exports.getCampusDeviceTypes = exports.updateCampusGroup = exports.updateCampusDevice = exports.setFlagStatus = exports.importCampusDevices = exports.getGroups = exports.getCampusDevices = exports.exportCampusDevices = exports.deleteGroup = exports.deleteCampusDevice = exports.addGroup = exports.addCampusDevice = void 0;
var addCampusDevice_1 = __importDefault(require("./addCampusDevice"));
exports.addCampusDevice = addCampusDevice_1.default;
var addGroup_1 = __importDefault(require("./addGroup"));
exports.addGroup = addGroup_1.default;
var deleteCampusDevice_1 = __importDefault(require("./deleteCampusDevice"));
exports.deleteCampusDevice = deleteCampusDevice_1.default;
var deleteGroup_1 = __importDefault(require("./deleteGroup"));
exports.deleteGroup = deleteGroup_1.default;
var exportCampusDevices_1 = __importDefault(require("./exportCampusDevices"));
exports.exportCampusDevices = exportCampusDevices_1.default;
var getCampusDevices_1 = __importDefault(require("./getCampusDevices"));
exports.getCampusDevices = getCampusDevices_1.default;
var getGroups_1 = __importDefault(require("./getGroups"));
exports.getGroups = getGroups_1.default;
var importCampusDevices_1 = __importDefault(require("./importCampusDevices"));
exports.importCampusDevices = importCampusDevices_1.default;
var setFlagStatus_1 = __importDefault(require("./setFlagStatus"));
exports.setFlagStatus = setFlagStatus_1.default;
var updateCampusDevice_1 = __importDefault(require("./updateCampusDevice"));
exports.updateCampusDevice = updateCampusDevice_1.default;
var updateCampusGroup_1 = __importDefault(require("./updateCampusGroup"));
exports.updateCampusGroup = updateCampusGroup_1.default;
var getCampusDeviceTypes_1 = __importDefault(require("./getCampusDeviceTypes"));
exports.getCampusDeviceTypes = getCampusDeviceTypes_1.default;
var searchCampusDevices_1 = __importDefault(require("./searchCampusDevices"));
exports.searchCampusDevices = searchCampusDevices_1.default;
var searchCampusGroups_1 = __importDefault(require("./searchCampusGroups"));
exports.searchCampusGroups = searchCampusGroups_1.default;
